import { PointKillConfig } from "../type";

export function processSnipConfig(configStr: string | undefined | null): PointKillConfig | undefined {
    if (!configStr) return;
    try {
      const res = JSON.parse(configStr);
      const { logs, traces, metrics } = res ?? {};

      if (res) {
        return {
          logs: { modules: Array.isArray(logs?.modules) ? logs.modules : [] },
          traces: { modules: Array.isArray(traces?.modules) ? traces.modules : [] },
          metrics: { modules: Array.isArray(metrics?.modules) ? metrics.modules : [] },
        };
      } else {
        return undefined
      }
    } catch (error) {
      console.error('Failed to parse sniping config:', error);
      return undefined
    }
  }